/**
 * AnchorCopyHandler — branche t="cpy" de Anchor : copie une string dans le clipboard
 * via une textarea hidden (legacy execCommand). Aucun changement de comportement.
 */

export function copyToClipboard(str: string): void {
    const el = document.createElement("textarea");
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    el.value = str;
    document.body.appendChild(el);
    const selection = document.getSelection();
    const selected = selection && selection.rangeCount > 0
        ? selection.getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected && selection) {
        selection.removeAllRanges();
        selection.addRange(selected);
    }
}
